export default __webpack_public_path__ + "static/media/10_hotel_manager.eee5c7a1.svg";